import {MultiTargetRelation} from '../MultiTargetRelation';
import type {ISketchObject} from '../../../../../mesh/sketch';


/**
 * 线关系多目标约束抽象基类。
 * 职责：
 * 1. 统一多实体线关系约束对象结构；
 * 2. 提供关系级几何落地结果构造能力。
 * @template TType 线关系类型。
 */
export function isSketchLineMultiRelationConstraint(value: object): value is SketchLineMultiRelationConstraint<any> {
    return Reflect.get(value, "isSketchLineMultiRelationConstraint") === true;
}
export abstract class SketchLineMultiRelationConstraint<T extends ISketchObject> extends MultiTargetRelation<T> {
    readonly isSketchLineMultiRelationConstraint: boolean = true;
}


